import { useKinerjaApi } from 'api/kinerja/utils/api'
import { apiPaths, queryKeyWithNpsn } from 'api/kinerja/kepala-sekolah/config'

import type { UseQueryOptions } from 'react-query'
import type {
  PerencanaanKsByDinasRole,
  PerencanaanKsByDinasState,
  PerencanaanKsByDinasTipe,
  ResponseAllPerencanaanKsByDinas,
  ResponseKinerjaKsByPs,
} from 'types/kinerja-ks'

export const API_GET_KS_ALL_PERENCANAAN_BY_DINAS_TAB_GURU_QUERY_KEY =
  'API_GET_KS_ALL_PERENCANAAN_BY_DINAS_TAB_GURU_QUERY_KEY'

export const API_GET_KS_PERENCANAAN_BY_DINAS_TAB_GURU_QUERY_KEY =
  'API_GET_KS_PERENCANAAN_BY_DINAS_TAB_GURU_QUERY_KEY'

export function useApiGetPerencanaanDinasTabGuru(
  id: string,
  opts?: UseQueryOptions<ResponseKinerjaKsByPs>
) {
  return useKinerjaApi<ResponseKinerjaKsByPs>(
    apiPaths.guruPerencanaanPltKsDinas,
    {
      axiosConfig: {
        params: {
          ptkId: id,
        },
      },
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: queryKeyWithNpsn(
        API_GET_KS_PERENCANAAN_BY_DINAS_TAB_GURU_QUERY_KEY,
        id
      ),
    }
  )
}

export function useApiGetAllPerencanaanDinasTabGuru(
  {
    state,
    role,
    tipe,
  }: {
    state?: PerencanaanKsByDinasState
    role?: PerencanaanKsByDinasRole
    tipe?: PerencanaanKsByDinasTipe
  },
  opts?: UseQueryOptions<ResponseAllPerencanaanKsByDinas>
) {
  return useKinerjaApi<ResponseAllPerencanaanKsByDinas>(
    `${apiPaths.guruPerencanaanPltKsDinas}/all`, // TODO Change URL
    {
      axiosConfig: {
        params: {
          state,
          role,
          tipe,
        },
      },
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: [
        API_GET_KS_ALL_PERENCANAAN_BY_DINAS_TAB_GURU_QUERY_KEY,
        ...(state ? [state] : []),
        ...(role ? [role] : []),
        ...(tipe ? [tipe] : []),
      ],
    }
  )
}
